<template>
 <div id="main_div">

   <!-- Home Section start-->
   <section id="home" class="home">
     <div class="home-decor">
       <div class="home-circle1"><img :src='"../assets/images/main-banner3.png"' alt=""></div>
       <div class="home-circle2"><img :src='"../assets/images/main-banner12.png"' alt=""></div>
       <div class="home-circle3"><img :src='"../assets/images/main-banner1.png"' alt=""></div>
     </div>
     <div class="container">
       <div class="row">
         <div class="col-md-5">
           <div class="home-contain">
             <div class="home-logo-container">
                <img :src='"../assets/images/square-logo.svg"' width="175" alt="logo">
               <p>With over 30 skills, Stoked Skills brings you the best Games and Apps for Alexa</p>
             </div>
           </div>
         </div>
         <div class="col-sm-6 offset-md-1" style="
            align-items: center;
            display: flex;
            justify-content: center;
        ">
           <div class="home-right">
             <!-- Tile js start -->
             <Tile :image = '"escapeshow.png"'/>
             <!-- Tile js end -->
           </div>
         </div>
       </div>
     </div>
   </section>
   <!--Home Section End -->

   <!-- Feature Section start -->
   <Feature/>
   <!-- Feature Section End -->

   <!-- About Start  -->
   <About/>
   <!-- About End -->

   <!-- Screenshots Section Start -->
   <Screenshots/>
   <!-- Screenshots Section End -->

   <!-- Team Section Start -->
   <Team/>
  <!-- team Section End -->

   <!-- blog Section Start
   <Latest-blog/>
   blog Section End -->

   <!-- Price Section start
   <Price/>
   Price Section End -->

   <!-- testimonial Section start
   <Testimonial/>
   testimonial Section End -->

   <!-- Contact Section start 
   <Contact_us/>
    Contact Section End -->

   <!--Subscribe section start-->
   <Subscribe/>
   <!--Subscribe section Ends-->

   <!--Map Section Start
   <Map/>
    Map Section Ends-->

   <!-- Footer Section start -->
  <Footer/>
   <!-- Footer Section End -->

   <js/>

 </div>
</template>
<script>
export default {
  name: 'home',
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>
<!--remove comment below line to set color -->
<!--<style lang="css">-->
  <!--@import '../public/assets/css/color/color-2.css';-->
<!--</style>-->

<style>
.home-logo-container {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/demo_page/home_one.vue